<template>
  <div class="layout">
    <div class="layout__header">
      <div class="layout__title">
        <h3>Términos y condiciones</h3>
      </div>
      <div class="layout__controls">
        <div class="form-inline">
          <button @click="botonConsultar" type="button" class="btn-info btn--bigger">
            <i class="fa fa-search"></i>
            <span>Consultar</span>
          </button>
          <button @click="botonNuevo" type="button" class="btn-success btn--bigger">
            <i class="fa fa-plus"></i>
            <span>Nuevo</span>
          </button>
        </div>
      </div>
    </div>
    <details class="card card--collapsible mt-2" open>
      <summary class="card__title card__title--bg-primary">
        <h5>Filtros de búsqueda</h5>
      </summary>
      <div class="card__content">
        <div class="row">
          <div class="col-xs-12 col-md-4">
            <div class="form-field select">
              <div class="select-field select-field--stretch">
                <select @change="changeEstado" v-model="form.estado" id="estado">
                  <option value="A">ACTIVO</option>
                  <option value="I">INACTIVO</option>
                  <option value="T">TODOS</option>
                </select>
                <label for="estado">Estado</label>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-md-8">
            <div class="form-inline">
              <label style="color: #435465; font-weight: 700;">Fecha:</label>
              <div class="form-field">
                <div class="datepicker-field datepicker-field--stretch">
                  <VueCtkDateTimePicker
                    id="fecha_desde"
                    v-model="form.fecha_desde"
                    locale="es"
                    only-datetime
                    no-label
                    button-now-translation="Ahora"
                    format="YYYY-MM-DD HH:mm"
                    formatted="YYYY-MM-DD HH:mm"
                    label="Seleccione fecha..."
                  />
                  <label>Desde</label>
                </div>
              </div>
              <div class="form-field">
                <div class="datepicker-field datepicker-field--stretch">
                  <VueCtkDateTimePicker
                    id="fecha_hasta"
                    v-model="form.fecha_hasta"
                    locale="es"
                    only-datetime
                    no-label
                    button-now-translation="Ahora"
                    format="YYYY-MM-DD HH:mm"
                    formatted="YYYY-MM-DD HH:mm"
                    label="Seleccione fecha..."
                  />
                  <label>Hasta</label>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-md-5">
            <input-field v-model="form.search" @keyup.enter="botonConsultar()" stretchMd id="search" placeholder="Consulta contenido...">
              <span>Consulta:</span>
            </input-field>
          </div>
        </div>
      </div>
    </details>
    <details v-if="registros.length" class="card card--collapsible mt-2" open>
      <summary class="card__title card__title--bg-primary">
        <h5>Lista</h5>
      </summary>
      <listaTerminosCondiciones
        ref="listaTerminosCondiciones"
        v-if="registros.length"
        :propRegistros="registros"
        :propForm="form"
        @consultar="consultarPagina"
        @editar="botonEditar"
        @eliminar="botonEliminar"
        @descargarPdf="botonDescargarPdf"
        />
    </details>
    <modal name="terminosCondiciones" width="80%" :clickToClose="false" height="auto" scrollable>
      <terminosCondiciones @cargarFila="cargarFila" :propTerminosCondiciones="terminos_condiciones"/>
    </modal>
  </div>
</template>
<script>
export default {
  props: {
  },
  data() {
    return {
      selectedIndex: -1,
      registros: [],
      terminos_condiciones: {
        contenido: '',
        path_archivo: '',
        estado: '',
      },
      form: {
        search: '',
        fecha_desde: ((moment(moment(), 'YYYY-MM-DD HH:mm:ss', 'es')).startOf('week').add(1, 'days')).format('YYYY-MM-DD 00:00'),
        fecha_hasta: (moment()).format('YYYY-MM-DD 23:59'),
        estado: 'A',
        pagination: {
          from: 0,
          last_page: 0,
          current_page: 1,
          per_page: 10,
          to: 0,
          total: 0,
          dropdown: false,
        }
      }
    }
  },
  mounted() {
    this.botonConsultar();
  },
  methods: {
    limpiarCampos: function(){
      this.selectedIndex = -1;
      this.terminos_condiciones.anular = false;
      this.terminos_condiciones.reactivar = false;
      this.terminos_condiciones.disableButton = false;
      this.terminos_condiciones.disabledInput = false;
      this.terminos_condiciones.id = '';
      this.terminos_condiciones.contenido = '';
      this.terminos_condiciones.path_archivo = '';
      this.terminos_condiciones.estado = 'N';

    },
    interruptor: function(estado, bool){
      this.terminos_condiciones.reactivar = bool;
      this.terminos_condiciones.disableButton = bool;
      this.terminos_condiciones.disabledInput = bool;
      this.terminos_condiciones.anular = estado == 'A'?true:false;
    },
    botonDescargarPdf: function(row){
      window.open(url + row.path_archivo, '_blank');
    },
    botonEditar: function(row){
      this.limpiarCampos();
      this.selectedIndex = this.registros.findIndex(registro => registro.id == row.id);
      this.terminos_condiciones.id = row.id;
      this.terminos_condiciones.contenido = row.contenido;
      this.terminos_condiciones.path_archivo = row.path_archivo;
      this.terminos_condiciones.estado = row.estado;
      if(row.estado == 'I')
        this.interruptor(row.estado, true);
      else
        this.interruptor(row.estado, false);
			this.$modal.show('terminosCondiciones');
    },
    changeEstado: function(){
      this.botonConsultar();
    },
    cargarFila: function(row){
      if(this.selectedIndex == -1)
        this.registros.unshift(row);
      else
        this.registros.splice(this.selectedIndex, 1, row);
    },
    botonNuevo: function(){
      this.$modal.show('terminosCondiciones');
      this.limpiarCampos();
    },
    resetPaginate: function(){
      this.form.pagination.from = 0;
      this.form.pagination.last_page = 0;
      this.form.pagination.current_page = 1;
      this.form.pagination.per_page = 10;
      this.form.pagination.to = 0;
      this.form.pagination.total = 0;
      this.form.pagination.dropdown = false;
    },
    consultarPagina: async function(param){
      this.form.pagination.current_page = param.currentPage;
      this.form.pagination.per_page = param.currentPerPage;
      this.form.pagination.dropdown = param.dropdown?true:false;
      await this.consultarLista();
    },
    consultarLista: async function(){
      await axios.get(url+ '/terminos-condiciones/consulta-terminos-condiciones', {params: this.form}).then(response => {
        let data = response.data;
        this.registros.splice(0, this.registros.length, ...data.info.data);
        this.form.pagination.from = data.info.from;
        this.form.pagination.last_page = data.info.last_page;
        this.form.pagination.current_page = data.info.current_page;
        this.form.pagination.per_page = data.info.per_page;
        this.form.pagination.to = data.info.to;
        this.form.pagination.total = data.info.total;
      });
    },
    botonConsultar: async function(){
      this.resetPaginate();
      this.registros.splice(0, this.registros.length);
      await this.consultarLista();
    },
    botonEliminar: function(row){
      this.selectedIndex = this.registros.findIndex(registro => registro.id == row.id);
      swal.fire({
					title: row.estado == 'I'?`¿Desea Re-activar los Términos y condiciones?`:`¿Desea anular los Términos y condiciones?`,
					text: "Esta acción requiere de confirmación.",
					icon: 'question',
					showCancelButton: true,
					confirmButtonText:'Aceptar'
			}).then((result) => {
        if (result.value) {
          axios.delete(url+ '/terminos-condiciones/delete/'+row.id).then(response => {
            let data = response.data;
            swal.fire((row.estado == 'A'?'Anulado':'Re-activado'), 'Los Términos y condiciones han sido ' +(row.estado == 'A'?'Anulado.':'Re-activado.'), 'success');
            if(this.form.estado == 'T')
              this.registros.splice(this.selectedIndex, 1, data);
            else
              this.registros.splice(this.selectedIndex, 1);
            this.selectedIndex = -1;
          }).catch(error => {
          if (error !== undefined && error !== null) {
            let response = error.response;
            if (response !== undefined && response !== null) {
                if(response.data.message != null && response.data.message != '')
                  swal.fire('Error', response.data.message, 'error');
                else
                  swal.fire("Hubo un error, intente nuevamente.", "Error", "error");
              }
            }
          });
        }
			});
    }
  },
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/terminos-condiciones/ConsultaTerminosCondiciones.vue